import { ShoppingBag, TrendingUp, Calendar, Zap, Award, Star } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

function fmtSince(d) {
  if (!d) return null;
  return new Date(d).toLocaleDateString("pt-PT", { month: "long", year: "numeric" });
}

function computeSaved(orders) {
  return orders.reduce((s, o) => s + (o.discount_amount || o.coupon_discount || 0), 0);
}

function computeCashbackTotal(orders) {
  return orders.reduce((s, o) => s + (o.cashback_earned || 0), 0);
}

function getFavProduct(orders) {
  const freq = {};
  orders.forEach(o => (o.items || []).forEach(item => {
    const name = item.name || item.product_name;
    if (name) freq[name] = (freq[name] || 0) + (item.quantity || 1);
  }));
  const top = Object.entries(freq).sort((a, b) => b[1] - a[1])[0];
  return top ? top[0] : null;
}

export function PortalCumulativeStats({ customer, orders }) {
  const totalSaved  = computeSaved(orders);
  const cashbackSum = computeCashbackTotal(orders);
  const since       = fmtSince(customer?.created_at);
  const favProduct  = getFavProduct(orders);
  const avgTicket   = (customer?.total_orders || 0) > 0
    ? (customer?.total_spent || 0) / customer.total_orders
    : null;

  const stats = [
    { Icon: ShoppingBag, label: "Total pedidos",   value: customer?.total_orders ?? 0,             color: "text-gray-800" },
    { Icon: TrendingUp,  label: "Total gasto",     value: `€${(customer?.total_spent || 0).toFixed(0)}`, color: "text-emerald-600" },
    avgTicket ? { Icon: Star,   label: "Ticket medio",   value: `€${avgTicket.toFixed(2)}`,           color: "text-blue-600" } : null,
    totalSaved > 0 ? { Icon: Award, label: "Total poupado", value: `€${totalSaved.toFixed(2)}`,  color: "text-indigo-600" } : null,
    cashbackSum > 0 ? { Icon: Zap,  label: "Cashback recebido", value: `€${cashbackSum.toFixed(2)}`, color: "text-amber-600" } : null,
    since ? { Icon: Calendar, label: "Cliente desde",    value: since,                               color: "text-gray-500", small: true } : null,
    favProduct ? { Icon: Star, label: "Prato favorito",  value: favProduct,                          color: "text-purple-600", small: true } : null,
  ].filter(Boolean);

  return (
    <Card>
      <CardContent className="p-4">
        <p className="text-sm font-bold text-gray-700 mb-3">Tus estadísticas</p>
        <div className="grid grid-cols-2 gap-2">
          {stats.map(s => (
            <div key={s.label} className="flex items-center gap-2.5 bg-gray-50 rounded-xl p-3">
              <s.Icon className={`w-4 h-4 shrink-0 ${s.color}`} />
              <div className="min-w-0">
                <p className={`font-bold ${s.small ? "text-sm" : "text-base"} ${s.color} leading-tight truncate`}>
                  {s.value}
                </p>
                <p className="text-[11px] text-gray-400 leading-tight">{s.label}</p>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
